import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import gsap from 'gsap'

export const initAlpine = () => {
  
  window.Alpine = Alpine
  window.gsap = gsap

  Alpine.plugin(collapse)
  
  Alpine.start()

}

export default () => {}